export const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: 'bottom' as const,
    },
  },
};

export const barOptions = {
  ...chartOptions,
  plugins: {
    legend: {
      display: false,
    },
  },
  scales: {
    y: {
      beginAtZero: true,
    },
  },
};

export const tokenFlowData = {
  labels: ['Inflow', 'Outflow'],
  datasets: [
    {
      data: [65, 35],
      backgroundColor: ['#685FD3', '#96CEF6'],
      borderColor: ['#685FD3', '#96CEF6'],
      borderWidth: 1,
    },
  ],
};

export const employeeUsageData = {
  labels: ['John', 'Sarah', 'Mike', 'Emma', 'David'],
  datasets: [
    {
      label: 'Token Usage (ETH)',
      data: [12, 19, 8, 15, 10],
      backgroundColor: '#685FD3',
      borderColor: '#685FD3',
      borderWidth: 1,
    },
  ],
};

export const departmentData = {
  labels: ['Finance', 'Canteen', 'Sales', 'Contractor'],
  datasets: [
    {
      data: [30, 20, 25, 10, 15],
      backgroundColor: ['#FFD664', '#6BDBF3', '#685FD3', '#B17FC9'],
      borderColor: ['#FFD664', '#6BDBF3', '#685FD3', '#B17FC9'],
      borderWidth: 1,
    },
  ],
};
